import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  extramarketData: [],
  error: false
};

const extramarketFilterSlice = createSlice({
  initialState,
  name: "extramarkterFilter",
  reducers: {
    getExtraMarketFilterStart: (state, action) => {
      state.loading = true;
    },
    getExtraMarketFilterSuccess: (state, action) => {
      state.loading = false;
      state.extramarketData = action.payload;
    },
    getExtraMarketFilterFailure: (state, action) => {
      state.loading = false;
      state.extramarketData = initialState.extramarketData;
    }
  }
});

export const {
  getExtraMarketFilterStart,
  getExtraMarketFilterSuccess,
  getExtraMarketFilterFailure
} = extramarketFilterSlice.actions;

export default extramarketFilterSlice.reducer;
